import React, {useState} from "react";
import {useSelector} from "react-redux";
import PropTypes from "prop-types";
import {selectLang, Translate} from "../../../../app/store/reducers/main/mainReducer";
import {syncVerificationActAsync} from "../../../../app/store/reducers/roaming/roamingVerificationActReducer";
import IconButton from "../../../common/IconButton";

const RoamingVerificationActSync = ({id, ...props}) => {
    const lang = useSelector(selectLang);
    const t = Translate;

    const [loading, setLoading] = useState(false);
    const syncVerificationAct = () => {
        setLoading(true);
        syncVerificationActAsync(id)
            .then()
            .catch()
            .finally(() => setLoading(false))
    };

    return (
        <IconButton
            icon={'fa-refresh'}
            variant="falcon-primary"
            onClick={syncVerificationAct}
            size="sm"
            iconClassName="me-1"
            disabled={loading}
            {...props}>
            {t(lang, "roaming.verification_act.sync")}
        </IconButton>
    )
};

RoamingVerificationActSync.propTypes = {
    id: PropTypes.string
}

RoamingVerificationActSync.defaulProps = {
    id: ""
}

export default RoamingVerificationActSync;